import { render } from "./ResetConfirm.vue?vue&type=template&id=831c3ce2"
import script from "./ResetConfirm.vue?vue&type=script&lang=js"
export * from "./ResetConfirm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__